module.exports = __webpack_public_path__ + "static/media/download-cxm-app.c250db4b.png";